const URL = '/services/card_payment';

export const SERVICES = {

  SERVICE_MSI: `${URL}/tools/get_msi_options`,

  CATALOGS_ROLES: `${URL}/catalog/roles`,

  COMMERCE: `${URL}/company/commerce`,

  COMPANY: `${URL}/company`,

  CONNECTOR_FLOW: '/internal/connector/:company/flows/:flow',

  CUSTOMER: `${URL}/customer/consult`,

  LINKS: `${URL}/transactions/link`,

  PAYMENT_METHODS: `${URL}/payment_methods/list`,

  PEOPLE_MASSIVE: '/private/clients/massive',

  PRODUCTS: `${URL}/products`,

  MASSIVE_METHODS: `${URL}/massive/methods`,

  RECURRING_CHARGERS: `${URL}/tools/massives`,
  RECURRING_CHARGERS_DETAILS: `${URL}/tools/massives/detail`,
  RECURRING_CHARGERS_REPROCESS: `${URL}/transactions/transactionNo3ds`,

  AUTOMATION_MANAGER_V2: `${URL}/automation-manager-v2`,

  //REPORTS: 'private/reports/config',
  //REPORTS_DATA: '/private/reports/loan_tape',
  //REPORTS_FIELDS: '/private/reports/loan_fields',
  REPORTS_GENERATE: `${URL}/generated-reports`,
  REPORTS_CREATE: `${URL}/reports/create`,
  REPORTS_GENERATE_HIDE: `${URL}/generated-report/hide`,
  //REPORTS_KPI: '/private/reports/kpi',
  //REPORTS_PDF: '/internal/financial/reports/panelpdf',
  REPORTS_STATICS: `${URL}/static-reports`,
  REPORT_SIGNIN_DOCUMENT: `${URL}/reports/sign-documents`,

  TAXONOMY: `${URL}/taxonomy`,
  TRANSACTIONS: `${URL}/main/transactions`,
  TRANSACTIONS_FILTERS: `${URL}/txn/search_filter`,
  TRANSACTION_DOWNLOAD: `${URL}/transactions/generate-receipt`,

  USER_PROPERTIES: `${URL}/tools/user-properties`,
  USERS_PROPERTIES: `${URL}/tools/users-properties`,
  DAILY_TOTAL: `${URL}/integrations/daily-totals`,

  USERS: `${URL}/users_details`,
  USERS_ADD: '/users/add',
  USERS_CHECK_DOCUMENT: '/users/checkKeyExist',
  USERS_GET_INFO: `${URL}/users/get_info`,
  USERS_GET_DETAIL: `${URL}/users_details`,
  USERS_OWNER: '/users/owner',
  USERS_PRESIGNIN_DOCUMENT: '/users/presignin_documents',
  USERS_KEYS: `${URL}/users/keys`,
  USERS_ROLES: `${URL}/users/roles`,
  USERS_ROLES_UPDATE: `${URL}/users/users_roles`,
  USERS_ROLES_TEMPLATE: `${URL}/users/rolestemplate`,

  //Sandbox 
  SANDBOX_GET_CARDS: `${URL}/sandbox/test-cards`,
  SANDBOX_GET_COMMERCES: `${URL}/sandbox/commerces/searches`,
  SANDBOX_POST_COMMERCES: `${URL}/sandbox/commerces`,
  SANDBOX_TRANSACTIONS_FILTERS: `${URL}/txn/search_filter`,
  SANDBOX_TRANSACTIONS_FILTERS_V2: `${URL}/txn/search_filter_v2`,
  SANDBOX_TAXONOMY: `${URL}/taxonomy`,
  SANDBOX_COMMERCE: `${URL}/company/commerce`,
  SANDBOX_TRANSACTION_DOWNLOAD: `${URL}/transaction/download`,
  SANDBOX_TEST_MATRIX_COMMERCE: `${URL}/sandbox/test-matrix/commerce/:commerceId`,
  SANDBOX_TEST_MATRIX_REQUEST_PRODUCTION: `${URL}/sandbox/test-matrix/request-production`,
};

export const CONF = {};
